import React, {Fragment} from 'react'

import {
  EuiBreadcrumbs,
  EuiSpacer
} from '@elastic/eui'


export default function ManualBreadcrumbs() {

  const breadcrumbs = [
    {
      text: 'Übersicht',
      href: '/de/Innenkameras/IN-6001_HD/',
    },
    {
      text: 'Spezifikationen',
      href: '/de/Innenkameras/IN-6001_HD/Technische_Spezifikationen/',
    },
    {
      text: 'Features',
      href: '/de/Innenkameras/IN-6001_HD/Produkt_Features/',
    },
    {
      text: 'Installation',
      href: '/de/Innenkameras/IN-6001_HD/Schnell_Installation/',
    },
    {
      text: 'P2P',
      href: '/de/Innenkameras/IN-6001_HD/Point2Point/',
    },
    {
      text: 'Objektivjustage',
      href: '/de/Innenkameras/IN-6001_HD/Objektivjustage/',
    },
    {
      text: 'Handbuch',
      href: '/de/Innenkameras/IN-6001_HD/Handbuch/',
    },
    {
      text: '◄ Innenkameras',
      href: '/de/Innenkameras/',
    }
  ];

  return (
    <Fragment>
      <EuiBreadcrumbs
        truncate={true}
        breadcrumbs={breadcrumbs}
        max={10}
        aria-label="INSTAR IN-6001 HD Online Usermanual Chapters"
      />
      <EuiSpacer />
    </Fragment>
  );
}